import { IAppState } from '../../redux';
import { selectIsAuctionSelected } from '../auction';
import { selectIsCalltrackingEnabled } from '../calltracking';

export const selectActiveAdditionalIds = (state: IAppState): Array<string> => {
  const isAuctionSelected = selectIsAuctionSelected(state);
  const isCalltrackingEnabled = selectIsCalltrackingEnabled(state);

  const services = [];

  if (isAuctionSelected) {
    services.push('auction');
  }

  if (isCalltrackingEnabled) {
    services.push('calltracking');
  }

  return services;
};
